module.exports = __webpack_public_path__ + "static/media/opentdb.7156d093.png";


//////////////////
// WEBPACK FOOTER
// /Users/sbardian/WebstormProjects/Reactjs/opentrivia-react/images/opentdb.png
// module id = 398
// module chunks = 0